export * from './analytics';
export * from './copy';
export * from './organizers';

/* GDPR */
export const NOTIFICATION_COOKIE = 'ebFollowOrganizerNotification';
export const NOTIFICATION_COOKIE_COLLECTION = 'ebFollowCollectionNotification';

const NOTIFICATION_COOKIE_EXPIRATION_MONTHS = 3;

export const NOTIFICATION_COOKIE_EXPIRATION_SECONDS =
    60 * 60 * 24 * 30 * NOTIFICATION_COOKIE_EXPIRATION_MONTHS;
